export const TUTORIAL_TARGET_WAIT_TIMEOUT_MS = 4000;
export const TUTORIAL_TAB_MOUNT_WAIT_MS = 2500;
export const TUTORIAL_TAB_TRANSITION_DELAY_MS = 350;

// Tier-1 readiness bound. Must cover a throttled successful table load: the tour waits for the
// [data-tour="table-loaded"] marker (rendered by Table when isLoading is false) before a step shows,
// so no step is drawn over the loading skeleton. Validate against a throttled-network measurement on
// the QA env and raise if a slow environment needs more.
export const TUTORIAL_TABLE_LOADED_WAIT_MS = 8000;

// Tier-2 bound. Once the table-loaded marker exists, a row-dependent target (a row pencil, a bulk
// action, an unmapped counter) either exists now or never will, so this stays short: a genuinely
// absent target fails fast and the step is skipped instead of freezing the tour.
export const TUTORIAL_ROW_TARGET_WAIT_MS = 800;

// Must cover the TabsLayout page slide-in enter transition (CSSTransition timeout={300} in
// src/layouts/TabsLayout/index.tsx, .slide-right-*-active in src/styles/app.scss) plus a small
// margin, so the routed <main> has settled to translate(0,0) before Joyride measures the target.
// If that transition duration changes, update this value.
export const TUTORIAL_PAGE_TRANSITION_WAIT_MS = 400;

// Caps the react-joyride `before` hook (default 5000 ms). The hook can run the tier-1 loaded-marker
// wait, then the route-change target wait, then the page-transition settle in sequence, so this must
// exceed their sum or Joyride cuts the hook off. Keep it above the three constants it references.
export const TUTORIAL_BEFORE_TIMEOUT_MS =
  TUTORIAL_TABLE_LOADED_WAIT_MS + TUTORIAL_TARGET_WAIT_TIMEOUT_MS + TUTORIAL_PAGE_TRANSITION_WAIT_MS + 1000;

export const sleep = (ms: number): Promise<void> => new Promise((resolve) => window.setTimeout(resolve, ms));
